import React from "react";
import { Box, Typography, Paper, FormControlLabel, Switch } from "@mui/material";
import { useThemeMode } from "../theme/ThemeContextProvider";

const Preferences = () => {
  const { mode, toggleTheme } = useThemeMode();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Preferences
      </Typography>

      <Paper sx={{ p: 3 }}>
        <FormControlLabel
          control={
            <Switch
              checked={mode === "dark"}
              onChange={toggleTheme}
            />
          }
          label={`Dark Mode: ${mode === "dark" ? "On" : "Off"}`}
        />
      </Paper>
    </Box>
  );
};

export default Preferences;
